import { ElementsTypes } from '@innowise-group/core';

export const defaultValues = {
  search: '',
  debouncedSearch: '',
  xRayString: '',
  debouncedXRayString: '',
  query: [{ type: ElementsTypes.Input, value: '' }],
};
